import MyProfile from "./DashboardMyProfile";

export default MyProfile;